import React, { useRef } from "react";
import { useT } from "@/lib/LanguageContext";
import CrmInput from "../../ui/CrmInput";
import CrmTextarea from "../../ui/CrmTextarea";
import MergeFieldPicker, { insertAtCaret } from "../../ui/MergeFieldPicker";
import { LABEL } from "../../ui/classes";
import { CRM } from "../../../../constants/testIds/crm";

/**
 * A step's subject + body (spec Sequence editor): plain text with merge-field chips.
 * `reminderButtons`, on session-reminder steps only, renders the wireframe's
 * non-editable Confirm / Reschedule / Join pills below the body — the server appends
 * them at send time (`automation/render.py`); this field never holds their markup.
 */
export default function EmailBodyEditor({ stepIndex, subject, onSubjectChange, body, onBodyChange, reminderButtons }) {
  const t = useT("crm");
  const area = useRef(null);

  const insert = (token) => {
    const { value, caret } = insertAtCaret(area.current, body, token);
    onBodyChange(value);
    requestAnimationFrame(() => { area.current?.focus(); area.current?.setSelectionRange(caret, caret); });
  };

  return (
    <div className="space-y-3">
      <div>
        <label htmlFor={`crm-seq-step-${stepIndex}-subject`} className={LABEL}>{t("seq.subjectLabel")}</label>
        <CrmInput id={`crm-seq-step-${stepIndex}-subject`} value={subject} placeholder={t("seq.subjectPlaceholder")}
          onChange={(e) => onSubjectChange(e.target.value)} data-testid={CRM.seqStepSubject(stepIndex)} />
      </div>
      <div>
        <label htmlFor={`crm-seq-step-${stepIndex}-body`} className={LABEL}>{t("seq.bodyLabel")}</label>
        <CrmTextarea id={`crm-seq-step-${stepIndex}-body`} ref={area} rows={6} value={body}
          onChange={(e) => onBodyChange(e.target.value)} data-testid={CRM.seqStepBody(stepIndex)} />
      </div>
      <MergeFieldPicker onInsert={insert} />
      {reminderButtons && (
        <div className="flex gap-2 pt-1" aria-hidden="true">
          <span className="rounded-full bg-eh-ink px-4 py-1.5 text-xs font-medium text-eh-bg">{t("seq.confirmReminder")}</span>
          <span className="rounded-full border border-eh-border-soft px-4 py-1.5 text-xs font-medium text-eh-ink">{t("seq.rescheduleReminder")}</span>
        </div>
      )}
    </div>
  );
}
